module.exports = __webpack_public_path__ + "static/tour-logo-b5fa03328446b692d371408686ccb264.png";